var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPremiumschutz = function SvgPremiumschutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.127,
    height: 88.51
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "premiumschutz_svg__a",
    x1: -2.164,
    x2: 9.306,
    y1: 31.863,
    y2: 33.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premiumschutz_svg__a",
    id: "premiumschutz_svg__c",
    x1: 60.837,
    x2: 67.853,
    y1: 42.814,
    y2: 43.841
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premiumschutz_svg__b",
    x1: 29.973,
    x2: 41.703,
    y1: 33.506,
    y2: 23.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fae588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9dc5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premiumschutz_svg__a",
    id: "premiumschutz_svg__d",
    x1: 40.302,
    x2: 28.295,
    y1: 29.383,
    y2: 25.102
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premiumschutz_svg__b",
    id: "premiumschutz_svg__e",
    x1: 19.942,
    x2: 31.671,
    y1: 50.811,
    y2: 40.815
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premiumschutz_svg__a",
    id: "premiumschutz_svg__f",
    x1: 30.27,
    x2: 18.263,
    y1: 46.688,
    y2: 42.407
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premiumschutz_svg__b",
    id: "premiumschutz_svg__g",
    x1: 40.005,
    x2: 51.735,
    y1: 50.811,
    y2: 40.815
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premiumschutz_svg__a",
    id: "premiumschutz_svg__h",
    x1: 50.334,
    x2: 38.327,
    y1: 46.688,
    y2: 42.407
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premiumschutz_svg__a",
    id: "premiumschutz_svg__i",
    x1: 4.008,
    x2: 56.274,
    y1: 32.546,
    y2: 40.203
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcefb4",
    d: "M35.563 88.51S53.2 73.588 59.513 66.118c9.008-10.651 13.495-42.895 10.87-56.575L35.563 0 .744 9.554c-2.625 13.67 1.861 45.913 10.87 56.564 6.313 7.47 23.95 22.392 23.95 22.392"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9dc5c",
    d: "M34.963 80.023c-5.313-4.655-14.81-13.155-18.74-17.79C9.728 54.55 5.183 29.403 6.156 14.968l.044-.646 29.364-8.062 29.365 8.051.044.646c.973 14.433-3.572 39.58-10.068 47.263C50.71 67.18 40.4 76.324 36.162 80.024l-.6.524Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae588",
    d: "M35.563 79.338c-6.058-5.308-14.9-13.277-18.644-17.693-6.37-7.534-10.8-32.6-9.855-46.617l28.5-7.824 28.499 7.814c.945 14.016-3.49 39.083-9.855 46.613-3.747 4.434-12.587 12.417-18.645 17.707"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premiumschutz_svg__a)",
    d: "M6.04 20.696a561 561 0 0 1-6.038-1.502 123.2 123.2 0 0 0 3.162 26.437q3.008-.875 5.873-1.501a120 120 0 0 1-2.996-23.434",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premiumschutz_svg__c)",
    d: "M64.416 30.404a108.8 108.8 0 0 1-4.908 22.776 56 56 0 0 1 4.936 4.035c2.997-7.566 5.084-17.54 6.057-26.859a77 77 0 0 1-6.085.048",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdf8e1",
    d: "m17.105 63.235-.15-.168c-.26-.288-.507-.57-.731-.833C9.727 54.55 5.182 29.402 6.155 14.967l.044-.646L34.286 6.61 6.018 13.662l-.468.128-.033.485-.043.646C4.492 29.477 9.11 54.88 15.702 62.675a68 68 0 0 0 6.065 5.32c-1.786-1.729-3.402-3.367-4.662-4.76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premiumschutz_svg__b)",
    d: "m36.232 19.473 2.177 4.41a.42.42 0 0 0 .314.228l4.866.707a.417.417 0 0 1 .232.712l-3.522 3.433a.42.42 0 0 0-.12.37l.832 4.846a.417.417 0 0 1-.606.44l-4.353-2.288a.42.42 0 0 0-.388 0l-4.353 2.288a.417.417 0 0 1-.605-.44l.831-4.847a.42.42 0 0 0-.12-.37l-3.521-3.432a.417.417 0 0 1 .231-.712l4.866-.707a.42.42 0 0 0 .315-.228l2.176-4.41a.417.417 0 0 1 .748 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premiumschutz_svg__d)",
    d: "M35.858 19.24a.41.41 0 0 1 .374.233l2.177 4.41a.42.42 0 0 0 .314.228l4.866.707a.417.417 0 0 1 .232.712l-3.522 3.433a.42.42 0 0 0-.12.37l.832 4.846a.416.416 0 0 1-.606.44l-4.353-2.288a.42.42 0 0 0-.388 0l-4.353 2.288a.416.416 0 0 1-.605-.44l.831-4.847a.42.42 0 0 0-.12-.37l-3.521-3.432a.417.417 0 0 1 .231-.712l4.866-.707a.42.42 0 0 0 .315-.228l2.176-4.41a.41.41 0 0 1 .374-.233m0-.432a.84.84 0 0 0-.762.474l-2.176 4.41-4.855.698a.85.85 0 0 0-.471 1.45l3.521 3.432-.835 4.834a.849.849 0 0 0 1.233.896l4.352-2.289 4.339 2.289a.85.85 0 0 0 1.233-.896l-.831-4.847 3.517-3.42a.85.85 0 0 0-.471-1.449l-4.867-.707-2.165-4.401a.84.84 0 0 0-.762-.474Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2c756",
    d: "m31.017 34.599.832-4.847a.42.42 0 0 0-.12-.37l-.203-.196a.4.4 0 0 1 .011.146l-.831 4.847a.41.41 0 0 0 .317.465c0-.016-.009-.029-.006-.045M38.72 24.303a.42.42 0 0 0 .315.228l4.866.707c.013.002.02.012.033.015a.407.407 0 0 0-.345-.435l-4.866-.707a.4.4 0 0 1-.122-.05ZM28.438 25.238l4.867-.707a.42.42 0 0 0 .314-.228l2.176-4.41a.41.41 0 0 1 .554-.184l-.116-.236a.417.417 0 0 0-.75 0l-2.175 4.41a.42.42 0 0 1-.315.228l-4.866.707a.417.417 0 0 0-.231.712l.196.191a.414.414 0 0 1 .346-.483"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premiumschutz_svg__e)",
    d: "m26.2 36.778 2.177 4.41a.42.42 0 0 0 .314.228l4.867.707a.417.417 0 0 1 .23.712l-3.52 3.433a.42.42 0 0 0-.12.37l.83 4.846a.417.417 0 0 1-.605.44l-4.352-2.288a.42.42 0 0 0-.389 0l-4.352 2.288a.417.417 0 0 1-.606-.44l.831-4.847a.42.42 0 0 0-.12-.37l-3.521-3.432a.417.417 0 0 1 .231-.712l4.866-.707a.42.42 0 0 0 .315-.228l2.176-4.41a.417.417 0 0 1 .749 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premiumschutz_svg__f)",
    d: "M25.826 36.545a.41.41 0 0 1 .375.233l2.176 4.41a.42.42 0 0 0 .314.228l4.867.707a.417.417 0 0 1 .23.712l-3.52 3.433a.42.42 0 0 0-.12.37l.83 4.846a.416.416 0 0 1-.605.44l-4.352-2.288a.42.42 0 0 0-.389 0l-4.353 2.288a.416.416 0 0 1-.605-.44l.831-4.847a.42.42 0 0 0-.12-.37l-3.521-3.432a.417.417 0 0 1 .231-.712l4.867-.707a.42.42 0 0 0 .314-.228l2.176-4.41a.41.41 0 0 1 .374-.233m0-.432a.85.85 0 0 0-.762.474l-2.176 4.41-4.855.698a.85.85 0 0 0-.471 1.45l3.521 3.432-.835 4.834a.849.849 0 0 0 1.233.896l4.352-2.289 4.339 2.289a.85.85 0 0 0 1.233-.896l-.831-4.847 3.517-3.42a.85.85 0 0 0-.471-1.449l-4.867-.707-2.165-4.401a.84.84 0 0 0-.762-.474",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2c756",
    d: "m20.985 51.904.832-4.847a.42.42 0 0 0-.12-.37l-.202-.196a.4.4 0 0 1 .01.146l-.831 4.847a.41.41 0 0 0 .317.465c0-.016-.008-.029-.006-.045M28.688 41.608a.42.42 0 0 0 .315.228l4.866.707c.013.002.02.012.033.015a.407.407 0 0 0-.344-.435l-4.867-.707a.4.4 0 0 1-.122-.05ZM18.407 42.543l4.866-.707a.42.42 0 0 0 .314-.228l2.177-4.41a.41.41 0 0 1 .553-.184l-.116-.236a.417.417 0 0 0-.749 0l-2.176 4.41a.42.42 0 0 1-.315.228l-4.866.707a.417.417 0 0 0-.231.712l.196.191a.414.414 0 0 1 .347-.483"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premiumschutz_svg__g)",
    d: "m46.264 36.778 2.177 4.41a.42.42 0 0 0 .314.228l4.866.707a.417.417 0 0 1 .232.712l-3.522 3.433a.42.42 0 0 0-.12.37l.832 4.846a.417.417 0 0 1-.606.44l-4.353-2.288a.42.42 0 0 0-.388 0l-4.353 2.288a.417.417 0 0 1-.605-.44l.83-4.847a.42.42 0 0 0-.12-.37l-3.52-3.432a.417.417 0 0 1 .23-.712l4.867-.707a.42.42 0 0 0 .314-.228l2.177-4.41a.417.417 0 0 1 .748 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premiumschutz_svg__h)",
    d: "M45.89 36.545a.41.41 0 0 1 .374.233l2.177 4.41a.42.42 0 0 0 .314.228l4.866.707a.417.417 0 0 1 .232.712l-3.522 3.433a.42.42 0 0 0-.12.37l.832 4.846a.416.416 0 0 1-.606.44l-4.353-2.288a.42.42 0 0 0-.388 0l-4.353 2.288a.416.416 0 0 1-.605-.44l.83-4.847a.42.42 0 0 0-.12-.37l-3.52-3.432a.417.417 0 0 1 .23-.712l4.867-.707a.42.42 0 0 0 .314-.228l2.177-4.41a.41.41 0 0 1 .374-.233m0-.432a.84.84 0 0 0-.762.474l-2.176 4.41-4.855.698a.85.85 0 0 0-.471 1.45l3.521 3.432-.835 4.834a.849.849 0 0 0 1.232.896l4.353-2.289 4.339 2.289a.85.85 0 0 0 1.233-.896l-.832-4.847 3.517-3.42a.85.85 0 0 0-.47-1.449l-4.867-.707-2.165-4.401a.84.84 0 0 0-.762-.474Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2c756",
    d: "m41.05 51.904.83-4.847a.42.42 0 0 0-.12-.37l-.202-.196a.4.4 0 0 1 .01.146l-.83 4.847a.41.41 0 0 0 .316.465c.001-.016-.008-.029-.005-.045M48.752 41.608a.42.42 0 0 0 .314.228l4.867.707c.013.002.02.012.033.015a.407.407 0 0 0-.345-.435l-4.866-.707a.4.4 0 0 1-.122-.05ZM38.47 42.543l4.867-.707a.42.42 0 0 0 .314-.228l2.176-4.41a.41.41 0 0 1 .554-.184l-.117-.236a.417.417 0 0 0-.748 0l-2.177 4.41a.42.42 0 0 1-.314.228l-4.866.707a.417.417 0 0 0-.232.712l.197.191a.414.414 0 0 1 .346-.483"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premiumschutz_svg__i)",
    d: "M9.732 43.057a75.8 75.8 0 0 1 15.427-1.666A58.2 58.2 0 0 1 59.051 51.73a110.3 110.3 0 0 0 4.335-20.452c-17.472-.668-41.674-5.874-56.397-9.416a122 122 0 0 0 2.743 21.195",
    style: {
      mixBlendMode: "soft-light"
    }
  })));
};
export default SvgPremiumschutz;